module.exports = __webpack_public_path__ + "static/front/img/logo.987c839f.svg";